document.addEventListener("DOMContentLoaded", () => {
  const producTitle = document.querySelector(".product__title").innerText;

  const wellnessColor = document.querySelectorAll(".ecoalf-wellness .color-shipping-container span");
  if (wellnessColor) {
    wellnessColor.forEach(el => {
      const [first, ...rest] = el.textContent.trim().split(' ');
      el.innerHTML = `<span class="first-word" style="font-weight: 600;">${first}</span> ${rest.join(' ')}`;
    });
  }

  const checkExist = setInterval(function () {
    const productRecommendations = document.querySelector(".product-recommendations__heading");

    if (productRecommendations) {
      const itemsList = productRecommendations.nextElementSibling;

      const items = itemsList.querySelectorAll("li");

      items.forEach((item) => {
        item.addEventListener("click", () => {
          const itemUrl = item.querySelector("a").href;
          const itemRecommendation = {
            item_url: itemUrl,
          };
          Shopify.analytics.publish("clic_related_product", itemRecommendation);
        });
      });
      clearInterval(checkExist);
    }

    const doofinderRecommendations = document.querySelector(".carousel-content");

    if (doofinderRecommendations) {
      doofinderRecommendations.addEventListener("click", () => {
        const doofinderRecommendationsObject = {
          product: producTitle,
          click_doofinder_recommendation: true,
        };
        Shopify.analytics.publish("clic_doofinder_recommendation", doofinderRecommendationsObject);
      });
    }

    const klarnaElement = document.querySelector("klarna-placement");

    if (klarnaElement) {
      klarnaElement.addEventListener("click", () => {
        const klarna = {
          product: producTitle,
          click_klarna: true,
        };
        Shopify.analytics.publish("clic_klarna", klarna);
      });
      clearInterval(checkExist);
    }
  }, 3000);

  const colors = document.querySelectorAll(".product__color");

  colors.forEach((color) => {
    color.addEventListener("click", () => {
      const colorsObject = {
        product: producTitle,
        colors: color.querySelector("span").innerText,
      };
      Shopify.analytics.publish("clic_color_product", colorsObject);
    });
  });

  const sizes = document.querySelectorAll("[data-get-size]");
  sizes.forEach((size) => {
    size.addEventListener("click", () => {
      const sizesObject = {
        product: producTitle,
        sizes: size.getAttribute("data-get-size"),
      };
      Shopify.analytics.publish("clic_size_product", sizesObject);
    });
  });

  const mediaProduct = document.querySelectorAll(".product__media-item");
  mediaProduct.forEach((media) => {
    media.addEventListener("click", () => {
      const mediaObject = {
        product: producTitle,
        open_image: true,
      };
      Shopify.analytics.publish("open_image_product", mediaObject);
    });
  });

  const modalSizes = document.querySelector(".product-popup-modal__button");
  modalSizes.addEventListener("click", () => {
    const modalSizesObject = {
      product: producTitle,
      open_size_modal: true,
    };
    Shopify.analytics.publish("clic_guia_tallas", modalSizesObject);
  });

  const detailsCollapse = document.querySelector(".product__accordion-details");
  detailsCollapse.addEventListener("click", () => {
    const detailsCollapseObject = {
      product: producTitle,
      open_details_collapse: true,
    };
    Shopify.analytics.publish("clic_detalles", detailsCollapseObject);
  });

  const shippingCollapse = document.querySelector(".shipping_returns_accordion");
  shippingCollapse.addEventListener("click", () => {
    const shippingCollapseObject = {
      product: producTitle,
      open_shipping_returns_collapse: true,
    };
    Shopify.analytics.publish("clic_envio_devoluciones", shippingCollapseObject);
  });

  const sustainabilityCollapse = document.querySelector(".product__accordion-sustainability");
  sustainabilityCollapse.addEventListener("click", () => {
    const sustainabilityCollapseObject = {
      product: producTitle,
      open_sustainability_collapse: true,
    };
    Shopify.analytics.publish("clic_informe_sostenibilidad", sustainabilityCollapseObject);
  });

  // Scroll to related products when cart is open on desktop devices
  // Disabled for now
  // if (window.innerWidth >= 750) {
  //   const waitForEl = function (selector, callback) {
  //     if (!!document.querySelectorAll(selector).length) {
  //       callback();
  //     } else {
  //       setTimeout(function () {
  //         waitForEl(selector, callback);
  //       }, 100);
  //     }
  //   };

  //   document.querySelector(".product-form__submit").addEventListener("click", function () {
  //     waitForEl("drawer-cart.is-active", function () {
  //       crollToRecommenProduct();
  //     });
  //   });

  //   function crollToRecommenProduct() {
  //     window.scrollTo({
  //       top:
  //         document.querySelector(".product__info-wrapper").clientHeight -
  //         360 -
  //         document.querySelector("product-recommendations").clientHeight,
  //       behavior: "smooth", // This enables smooth scrolling
  //     });
  //   }
  // }
});
